const Portfolio = () => {
  const data = [
    {
      id: 1,
      image: `${window.location.origin}/images/portfolio1.jpg`,
      title: "Insta-Clone Next.js App",
      github: "https://github.com/amir-h-e",
      demo: "https://instagram-clone-rho-gules.vercel.app/",
    },
    {
      id: 2,
      image: `${window.location.origin}/images/portfolio2.jpg`,
      title: "Youtube-Clone React App",
      github: "https://github.com/amir-h-e",
      demo: "https://youtube-clone-xi-nine.vercel.app/",
    },
    {
      id: 3,
      image: `${window.location.origin}/images/portfolio3.jpg`,
      title: "Netflix-Clone React App",
      github: "https://github.com/amir-h-e",
      demo: "https://netflix-clone-pearl-nine.vercel.app/",
    },
    {
      id: 4,
      image: `${window.location.origin}/images/portfolio4.jpg`,
      title: "Shopping Card App",
      github: "https://github.com/amir-h-e",
      demo: "https://shopping-cart-context-alpha.vercel.app/",
    },
    {
      id: 5,
      image: `${window.location.origin}/images/portfolio5.jpg`,
      title: "Piano App",
      github: "https://github.com/amir-h-e",
      demo: "https://piano-jsapp.netlify.app/",
    },
    {
      id: 6,
      image: `${window.location.origin}/images/portfolio6.png`,
      title: "Weather App",
      github: "https://github.com/amir-h-e",
      demo: "https://amirhebrahimi.com/portfolio/weather/",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio_container">
        {data.map(({ id, image, title, github, demo }) => (
          <article key={id} className="portfolio_item">
            <div className="portfolio_item-image">
              <img src={image} alt={title} />
            </div>
            <h3>{title}</h3>
            <div className="portfolio_item-cta">
              {/* <a href={github} className="btn" target="_blank">
                github
              </a> */}
              <a href={demo} className="btn btn-primary" target="_blank">
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
